import { StatusChipBg, StatusChipText } from '@labrav/react-components'

export interface ChipStyle {
  label: string
  bg: StatusChipBg
  text: StatusChipText
}

const toTitleCase = (status: string) =>
  status
    .toLowerCase()
    .split('_')
    .map(word =>
      word === 'aws' ? 'AWS' : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ')

export const statusChip = (status: string): ChipStyle => {
  const styles: Record<string, ChipStyle> = {
    ACTION_REQUIRED: {
      label: 'Action required',
      bg: StatusChipBg.ORANGE,
      text: StatusChipText.ORANGE,
    },
    SUBMITTED: {
      label: 'Submitted',
      bg: StatusChipBg.LIGHTBLUE,
      text: StatusChipText.LIGHTBLUE,
    },
    APPROVED: {
      label: 'Approved',
      bg: StatusChipBg.GREEN,
      text: StatusChipText.GREEN,
    },
    PAID: { label: 'Paid', bg: StatusChipBg.GREEN, text: StatusChipText.GREEN },
    REJECTED: {
      label: 'Rejected',
      bg: StatusChipBg.RED,
      text: StatusChipText.RED,
    },
    DRAFT: { label: 'Draft', bg: StatusChipBg.GRAY, text: StatusChipText.GRAY },
  }
  return (
    styles[status] ?? {
      label: toTitleCase(status),
      bg: StatusChipBg.GRAY,
      text: StatusChipText.GRAY,
    }
  )
}
